
import React from "react";
import { useUser } from "../../context/UserContext";

import {
	Container,
	Button,
	Navbar,
	Nav,
   NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";

const Header = () => {
	const { isLoggedIn, userData, logout } = useUser();

	return(
	<header id="header">
		<Navbar expand="lg" fixed="top" className="bg-body-tertiary border-bottom border-gray">
            <Container>
                <Navbar.Brand href="/">
					 	<img
							src="images/MALogo.png"
							height="25"
							className="d-inline-block align-top"
							alt="MindAntix logo"
						/>
					 </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
					 	
                    <Nav.Link as={Link} to="/home">Home</Nav.Link>
						  <Nav.Link as={Link} to="/about">About</Nav.Link>
						
						  
                    <NavDropdown title="Products" id="basic-nav-dropdown">
                        <NavDropdown.Item href="/hackingcreativity" style={{fontWeight: "bold"}}>Organizational Innovation</NavDropdown.Item>
                        <NavDropdown.Item href="/orgassessment"> -Culture Assessment</NavDropdown.Item>
                        <NavDropdown.Item href="/hackingcreativity"> -InnovationFirst Strategy</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/online" style={{fontWeight: "bold"}}>K-12 Creativity Platform</NavDropdown.Item>
                        <NavDropdown.Item href="/brainteasers">-Cognitive Brainteasers</NavDropdown.Item>
                        <NavDropdown.Item href="/pbl">-Project Based Learning</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/" style={{fontWeight: "bold"}}>Professional Development</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/">FAQ</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="/casestudies">Case Studies</Nav.Link>
						  <Nav.Link href="/speaking">Speaking</Nav.Link>
						  <Nav.Link href="/tldllv">Book</Nav.Link>
                    <Nav.Link target="_blank" href="https://blog.mindantix.com/">Blog</Nav.Link>
                    
							{!isLoggedIn && (
								<Link to="/login">
									<Button layout="link">
									<span>Login</span>
									</Button>
								</Link>
							)
							}

							{isLoggedIn && (
								<Link className="w-full" onClick={() => logout()} to="/">
									<Button>
									Logout
									</Button>
								</Link>
							)}
						  
                </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
	</header>
	);
};

export default Header; 
